// File: src/components/pages/Templates.jsx
// Tab-based page with Publish tab added

import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import SlotTemplates from '../SlotTemplates';
import Publish from './Publish';
import '../../styles/templates.css';

export default function Templates() {
  const [activeTab, setActiveTab] = useState('templates');

  const tabs = [
    { id: 'templates', label: 'Templates' },
    { id: 'publish', label: 'Publish' },
    { id: 'activate', label: 'Activate' },
    { id: 'changes', label: 'Changes' }
  ];

  return (
    <div className="page-container">
      {/* Page Header 
      <div className="page-header">
        <div className="page-title-wrapper">
          <Calendar className="page-icon" size={32} />
          <h1 className="page-title">Slot Template</h1>
        </div>
      </div>
      */}
      {/* Tab Navigation */}
      <div className="tab-navigation">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content-wrapper">
        {/* Templates Tab - Reuse existing component */}
        {activeTab === 'templates' && (
          <SlotTemplates />
        )}

        {/* Publish Tab - NEW */}
        {activeTab === 'publish' && (
          <Publish />
        )}

        {/* Activate Tab */}
        {activeTab === 'activate' && (
          <div className="tab-content-placeholder">
            <h2>Activate Template</h2>
            <p>Activate or deactivate your templates</p>
            {/* TODO: Implement Activate component */}
          </div>
        )}

        {/* Changes Tab */}
        {activeTab === 'changes' && (
          <div className="tab-content-placeholder">
            <h2>Change History</h2>
            <p>View history of changes made to your templates</p>
            {/* TODO: Implement Changes/History component */}
          </div>
        )}
      </div>
    </div>
  );
}